import React from "react";
import { Box } from "@mui/material";
import BlendingMasterData from "./BlendingMasterData";
import { GlobalTabCollection, StyledTab } from "../../../pages/styles";
import BlendFacilityManagement from "./BlendFacilityManagement";

const BlendingAdminMenu = ({ ...props }) => {
  const [tabValue, setTabValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const renderSearchTab = () => {
    switch (tabValue) {
      case 0: {
        return <BlendFacilityManagement></BlendFacilityManagement>
      }
      case 1: {
        return <BlendingMasterData></BlendingMasterData>
      }
      default: {
        alert(tabValue);
      }
    }
  };

  return (
    <>
      <div>
        <Box sx={{ bgcolor: "#fff"}}>
          <GlobalTabCollection value={tabValue} onChange={handleChange} aria-label='ant example'>
            <StyledTab label='Blend Facility' />
            <StyledTab label='Master Data' />
          </GlobalTabCollection>
          <Box sx={{ p: 3 }} />
        </Box>
        {renderSearchTab()}
      </div>
    </>
  );
};

export default BlendingAdminMenu;
